import React, { useContext } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { Pagination } from '@which/seatbelt'

import type { PageParams } from '../../../../../routes'
import { focusAboveCompareTray } from '../../../../../shared/components/ReviewsCompareTray/utils'
import { SkipButton } from '../../../../../shared/components/SkipButton'
import { useFullUrl } from '../../../../../shared/hooks/useFullUrl'
import { usePageProps } from '../../../../../shared/usePageProps'
import { removeUrlQueryStringAndFragment } from '../../../../../shared/utils/remove-url-query-string-and-fragment'
import { updateUrlQueryParams } from '../../../../../shared/utils/update-url-query-params'
import { ReviewsTemplateContext } from '../../ReviewsTemplateContext'
import styles from './ReviewsPagination.module.scss'

export const ReviewsPagination = React.forwardRef<HTMLElement, Props>(({ numberOfPages }, ref) => {
  const history = useHistory()
  const { search } = useLocation()
  const { fetchMore, pageNumberOnFilterInteraction, setPageNumberOnFilterInteraction } =
    useContext(ReviewsTemplateContext)
  const { categorySlug } = useParams<PageParams>()
  const { context } = usePageProps()
  const searchParams = new URLSearchParams(search)
  const pageNumber = searchParams.get('page')?.replace(/\D/g, '') || '1'
  const { getFullUrl } = useFullUrl()

  const handlePaginationClick = (page: number) => {
    window.scrollTo(0, 0)
    fetchMore({
      variables: {
        categorySlug,
        context: context || '',
        pageNumber: `${pageNumberOnFilterInteraction || page}`,
      },
    })
    const firstProductCard = (ref as React.RefObject<HTMLElement>)?.current?.querySelector(
      '[class^="ProductCard"]'
    ) as HTMLElement
    firstProductCard?.focus()
    const updatedUrl = updateUrlQueryParams({ page: page === 1 ? '' : page })
    updatedUrl && history.replace(updatedUrl, null)
    setPageNumberOnFilterInteraction && setPageNumberOnFilterInteraction(null)
  }

  return (
    <section className={styles.reviewsPagination} data-testid="reviews-pagination">
      <Pagination
        className={styles.pagination}
        callback={handlePaginationClick}
        totalPages={numberOfPages}
        currentPage={pageNumberOnFilterInteraction || Number(pageNumber)}
        onFocus={focusAboveCompareTray}
        href={removeUrlQueryStringAndFragment(getFullUrl())}
      />
      <SkipButton
        className={styles.paginationSkipButton}
        selector='a[data-which-id="gn-main-content-skip-link"]'
      >
        Skip to top
      </SkipButton>
    </section>
  )
})

//////IMPLEMENTATION//////

type Props = {
  numberOfPages: number
}
